import { useAtom } from 'jotai';
import { persistedOverviewAtom } from '../atoms';

/**
 * Hook to access flow data from atoms
 */
function useFlowOverview() {
  const [{ flows }] = useAtom(persistedOverviewAtom);

  // Get ordered flow IDs from the flows object
  const orderedFlowIds = Object.entries(flows)
    .sort(([, a], [, b]) => a.order - b.order)
    .map(([id]) => id);

  return {
    name: 'overview-flow-store',
    flows: orderedFlowIds,
    flowsData: flows,
  };
}

export default useFlowOverview;
